import {Component, effect, linkedSignal, model} from '@angular/core';
import {GeoCoords} from '../../interfaces/geo-and-movement.interfaces';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormField, MatInput, MatLabel, MatSuffix} from '@angular/material/input';
import {TranslocoDirective} from '@ngneat/transloco';

@Component({
  selector: 'lib-coordinates-inputs',
  imports: [
    FormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    MatFormField,
    TranslocoDirective
  ],
  templateUrl: './coordinates-inputs.component.html',
  styleUrl: './coordinates-inputs.component.scss'
})
export class CoordinatesInputsComponent {
  coords = model.required<GeoCoords>();

  lng = linkedSignal({
    source: this.coords,
    computation: (coords) => coords.lng,
  });
  lat = linkedSignal({
    source: this.coords,
    computation: (coords) => coords.lat,
  });

  constructor() {
    effect(() => {
      this.coords.set({
        lng: this.lng(),
        lat: this.lat()
      });
    });
  }
}
